module.exports = __webpack_public_path__ + "img/Frame 751.2cecc7dc.png";